<template>
  <div id="app">
    <router-view/>
    <AccountModal v-if="showModal" @closeModal="closeModal()"></AccountModal>
    <SavedSpacesModal v-if="showSavedModal"></SavedSpacesModal>
  </div>
</template>

<script>
import AccountModal from "../../components/search/AccountModal"
import SavedSpacesModal from "../../components/search/SavedSpacesModal"


export default {
  name: 'App',
  data: () => ({
    showModal: false,
    showSavedModal: false
  }),
  created() {
    // Commit Translations to Store passing the globalTranslations variable from pitch.html.erb
    this.$store.commit('setTranslations', globalTranslations)
    this.populateStore()
  },
  props: [],
  components: {
    AccountModal,
    SavedSpacesModal
  },
  mounted () {
    this.handleModal()
  },
  watch: {
    // Watch for state changes
    '$store.state.savedModal': function (val) {
         this.showSavedModal = val
    }
  },
  methods: {
    paramsToObject(entries) {
      const result = {}
      for(const [key, value] of entries) {
        result[key] = value
      }
      return result
    },
    closeModal () {
      this.showModal = false
    },
    handleModal () {
      var self = this
      if(!is_session){
      // setTimeout(function () {
      //   if (!self.showSavedModal) {
      //     self.showModal = true
      //   }
      // }, 30000);
      }
    },
    populateStore () {
      const queryString = window.location.search
      const urlParams = new URLSearchParams(queryString)

      /*
      distance: null,
      category_id: [],
      amenity_id: [],
      from_date: null,
      to_date: null,
      from_price: null,
      to_price: null,
      from_footfall: null,
      to_footfall: null,
      bounds: {
        latitude: null,
        longitude: null,
        latitude2: null,
        longitude2: null
      },
      */
      this.$store.commit('distance', urlParams.get('distance'))
      this.$store.commit('category_id', urlParams.get('category_id') ? urlParams.get('category_id').split(',').map(element => { return element }) : null)
      this.$store.commit('amenity_id', urlParams.get('amenity_id') ? urlParams.get('amenity_id').split(',').map(element => { return Number(element) }) : null)
      this.$store.commit('feature_id', urlParams.get('feature_id') ? urlParams.get('feature_id').split(',').map(element => { return String(element) }) : null)
      this.$store.commit('from_price', urlParams.get('from_price') ? Number(urlParams.get('from_price')) : null)
      this.$store.commit('to_price', urlParams.get('to_price') ? Number(urlParams.get('to_price')) : null)
      this.$store.commit('from_footfall', urlParams.get('from_footfall') ? Number(urlParams.get('from_footfall')) : null)
      this.$store.commit('to_footfall', urlParams.get('to_footfall') ? Number(urlParams.get('to_footfall')) : null)
      this.$store.commit('lat', urlParams.get('lat') ? Number(urlParams.get('lat')) : null)
      this.$store.commit('lng', urlParams.get('lng') ? Number(urlParams.get('lng')) : null)
      this.$store.commit('query', urlParams.get('query') ? urlParams.get('query') : null)
      this.$store.commit('location_type', urlParams.get('location_type') ? urlParams.get('location_type') : null)
    }  
  }
}
</script>

<style lang="scss">
@import "../../scss/global/includes";
@import '../../scss/global/fonts.scss';

html, body {
  /* give this to all tags from html to .fullscreen */

  height: 100%;
  -webkit-font-smoothing: antialiased;
  margin: 0;
  padding: 0;
}
body {
  font-family: $font-light;
  color: $strong-light;
  font-size: 16px;
  line-height: 1.4;
}

canvas {
  cursor: default !important;
}
*, *:before, *:after {
  box-sizing: border-box;
}
a {
  text-decoration: none;
  color: $strong-light;
}
a:focus {
  text-decoration: none;
  outline: none;
  color: inherit;
}
a:hover {
  color: $primary;
  text-decoration: none;
}
::selection {
  background: $primary;
  /* WebKit/Blink Browsers */

  color: $light;
}
::-moz-selection {
  background: $primary;
  /* Gecko Browsers */

  color: $light;
}
img {
  max-width: 100%;
}
strong {
  font-family: $font-bold;
  font-weight: normal;
}
ul {
  margin: 0;
  padding: 0;
}
textarea, input {
  outline: none !important;
  font-family: $font-light;
  color: $strong-light;
}
button {
  border: 0;
  padding: 0;
  background: transparent;
  font-family: $font-light;
  color: $strong-light;
  outline: none;
  cursor: pointer;
}

img[lazy] {
  opacity: 0;
  transition: all 0.6s ease-in-out;
}
img[lazy=loading] {
  opacity: 0;
  transition: all 0.6s ease-in-out;
}
img[lazy=error] {
}
img[lazy=loaded] {
  opacity: 1;
}

html[organisation=Nhood] {
 .centre-page .space-tags {
    display: none;
  }
}

#app {
  min-height: 100vh;
  min-height: 100svh;
}
</style>
